import AxiosControl from '../components/axios/AxiosControl'
import { getErrorMessage, getResponseData, getResponseMessage, isSuccessResponse } from '../helpers/apiResponse'
const Axios = AxiosControl()

export const getDelegations = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'DELEGATION_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/delegation/getAll', {page, limit, search}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DELEGATION_GETALL_SUCCESS',
                payload: getResponseData(data)
            })
        }
    } catch (error) {
        dispatch({
            type: 'DELEGATION_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const addDelegation = (delegationdata) => async (dispatch) => {
    dispatch({
        type: 'DELEGATION_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/delegation/create', delegationdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DELEGATION_ADD_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'DELEGATION_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const editDelegation = (delegationId, delegationdata) => async (dispatch) => {
    dispatch({
        type: 'DELEGATION_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/delegation/edit/'+ delegationId, delegationdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DELEGATION_EDIT_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'DELEGATION_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const resetDelegationResult = () => (dispatch) => {
    dispatch({
        type: 'DELEGATION_RESET_RESULT'
    })
}